import { Routes } from '@angular/router';
import { DashboardPrePrestador } from '@/features/registro/pre-prestador/dashboard-pre-prestador/dashboard-pre-prestador';
import { PrePrestadorContent } from '@/features/registro/pre-prestador/pre-prestador-content';

const rootPath = 'preprestador';

/**
 * Define as rotas do módulo de Arrecadação:
 * - /arrecadacao: Rota principal que carrega o layout `ArrecadacaoContent`.
 * - Rota padrão ('') -> `DashboardArrecadacao`
 * - Rota 'relatorios' -> `Relatorios`
 */
export const prePrestadorRoutes: Routes = [
    {
        path: rootPath,
        component: PrePrestadorContent,
        children: [{ path: '', component: DashboardPrePrestador }]
    }
];
